<template>
  <div class="question-item-component mb-3">
    <div class="d-flex align-items-center justify-content-between">
      <button
        class="btn btn-header p-0 m-0"
        @click.prevent="editing = !editing"
      >
        <i class="ph ph-dots-six-vertical handle lead fs-14" />
        <h5 class="text-semibold">
          {{ item.question }}
        </h5>
        <i class="ph ph-caret-down" />
      </button>
    </div>
    <template v-if="editing">
      <div class="d-flex flex-column gap-4 mt-4">
        <snow-input v-model="item.question" id="question" label="Pergunta*" />

        <snow-input
          type="textarea"
          v-model="item.answer"
          id="answer"
          label="Resposta*"
        />
        <div class="d-flex align-items-center justify-content-between">
          <snow-button
            v-if="editing"
            size="sm"
            variant="danger"
            text="excluir"
            @click="onRemove"
          />
          <snow-button
            size="sm"
            variant="gray"
            text="Salvar"
            :disabled="!isValid"
            @click="submit"
          />
        </div>
      </div>

      <confirmation
        iconType="warning"
        title="Aviso"
        cancelButtonText="Cancelar"
        v-model="dialog_remove"
        confirmButtonClass="btn-danger"
        confirmButtonText="Confirmar"
        :text="`Deseja mesmo excluir a pergunta: ${item.question}`"
        @confirm="submitDelete"
        @cancel="dialog_remove = false"
      />
    </template>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
    index: Number
  },
  mounted() {
    if (!this.item?.id) {
      this.editing = true;
    }
  },
  data: () => ({ loading: false, editing: false, dialog_remove: false }),
  computed: {
    isValid() {
      return this.item.question.length && this.item.answer.length;
    }
  },
  methods: {
    cancelEdit() {
      this.$emit("update");
      this.editing = false;
    },
    onRemove() {
      if (this.item.id) {
        this.dialog_remove = true;
      } else {
        this.$emit("remove", this.index);
      }
    },
    submit() {
      if (this.loading) return;

      const payload = {
        product_id: this.$route.params.id,
        ...this.item,
        sort: this.index
      };

      let action = "membersSetup/postFAQ";

      if (this.item.id) {
        action = "membersSetup/putFAQ";
        delete payload.company_id; // unecessary field
      }

      if (!this.item.question.length) {
        this.$message.warning(`Digite o título da pergunta ${this.index + 1}.`);
        return;
      }

      if (!this.item.answer.length) {
        this.$message.warning(
          `Digite o título a resposta da pergunta ${this.index + 1}.`
        );
        return;
      }

      this.loading = true;
      this.$store
        .dispatch(action, payload)
        .then(response => {
          this.$message.success(`A pergunta ${this.index + 1} foi salva!`);
          this.editing = false;
          const faqs = [...this.$store.state.membersSetup.faqs];
          faqs.splice(this.index, 1, response.data);
          this.$store.commit("membersSetup/setFaqs", faqs);
        })
        .catch(() => {
          this.$message.error(
            `Não foi possível salvar a pergunta ${this.index + 1}!`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitDelete() {
      this.$store
        .dispatch("membersSetup/deleteFAQ", this.item.id)
        .then(() => {
          this.$message.success(`A pergunta ${this.index + 1} foi deletada!`);
          this.$store.commit(
            "membersSetup/setFaqs",
            this.$store.state.membersSetup.faqs.filter(
              f => f.id !== this.item.id
            )
          );
        })
        .catch(() => {
          this.$message.error(
            `Não foi possível deletar a pergunta ${this.index + 1}!`
          );
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.question-item-component {
  border-radius: 16px;
  border: 1px solid var(--dark-10);
  background: var(--bg-1);
  padding: 24px;
  transition: 0.3s border;

  &:hover {
    border: 1px solid var(--dark-40);
  }

  .btn-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 20px;
  }

  .lead {
    cursor: grab;
  }
}
</style>
